import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.y6q_1 = partyId;
        this.z6q_1 = playerId;
        this.a6r_1 = name;
        this.b6r_1 = email;
        this.c6r_1 = badge;
        this.d6r_1 = callSignAdjective;
        this.e6r_1 = callSignNoun;
        this.f6r_1 = imageURL;
        this.g6r_1 = avatarType;
        this.h6r_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.y6q_1.toString() + ', playerId=' + this.z6q_1.toString() + ', name=' + this.a6r_1 + ', email=' + this.b6r_1 + ', badge=' + this.c6r_1.toString() + ', callSignAdjective=' + this.d6r_1 + ', callSignNoun=' + this.e6r_1 + ', imageURL=' + toString(this.f6r_1) + ', avatarType=' + toString(this.g6r_1) + ', unvalidatedEmails=' + toString(this.h6r_1) + ')';
      }
      hashCode() {
        var result = this.y6q_1.hashCode();
        result = imul(result, 31) + this.z6q_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b6r_1) | 0;
        result = imul(result, 31) + this.c6r_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.d6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e6r_1) | 0;
        result = imul(result, 31) + hashCode(this.f6r_1) | 0;
        result = imul(result, 31) + hashCode(this.g6r_1) | 0;
        result = imul(result, 31) + hashCode(this.h6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.y6q_1.equals(other.y6q_1))
          return false;
        if (!this.z6q_1.equals(other.z6q_1))
          return false;
        if (!(this.a6r_1 === other.a6r_1))
          return false;
        if (!(this.b6r_1 === other.b6r_1))
          return false;
        if (!this.c6r_1.equals(other.c6r_1))
          return false;
        if (!(this.d6r_1 === other.d6r_1))
          return false;
        if (!(this.e6r_1 === other.e6r_1))
          return false;
        if (!equals(this.f6r_1, other.f6r_1))
          return false;
        if (!equals(this.g6r_1, other.g6r_1))
          return false;
        if (!equals(this.h6r_1, other.h6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
